import rootUrl from "../url";

export default rootUrl + "api/send-email-notification/";